module.exports = __webpack_public_path__ + "media/packs/src/assets/images/user-default-8afb6141846a1abfdebff1d99f34f6f1.png";